import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import OtpInput from "react-otp-input";
import { Box, Dialog, DialogContent, Grid, Typography, IconButton } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import CloseIcon from "@mui/icons-material/Close";
import { verifyProfile } from "redux/actions/UserProfile";
import Timer from "pages/otp/Timer";
import BackDrop from "components/backDrop/BackDrop";

function CommonOtpDialog(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [autoFocusOtp, setAutoFocusOtp] = useState(true);
  const userOtp = useSelector((state) => state);
  const isLoader = userOtp?.userOtp?.loading;
  const otpSecret = localStorage.getItem("verifySecretToken");
  const verifyProfieLoader = useSelector((state) => state.userVerifyProfile?.loading);
  const updateProfileLoader = useSelector((state) => state?.userUpdateProfile?.loading);

  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm();
  const [errorOtp, setErrorOtp] = useState("");
  const onSubmit = (data) => {
    const otpDetails = {
      platform: "CustomerApp",
      otp: data,
      otpSecret: otpSecret,
    };
    dispatch(verifyProfile(otpDetails, props?.handleClose ? handleClose : 'Resend'));
  };

  useEffect(() => {
    const mobile = localStorage.getItem("mobile");
    if (!mobile) {
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    if (isLoader) {
      setAutoFocusOtp(false);
    }
  }, [isLoader]);

  const handleOtpChange = (value) => {
    if (value.length === 4) {
      setErrorOtp("");
      onSubmit(value);
      reset();
    } else {
      setErrorOtp("OTP must be 4 characters long");
    }
  };

  const onResend = () => {
    reset();
    setErrorOtp("");
  };

  const handleClose = () => {
    props.handleClose();
  };

  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={props?.open}
        maxWidth={"sm"}
        className="dialogStyle"
      >
        <DialogContent>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box sm={{ flexGrow: 1 }}>
            <Grid container spacing={2} className="padding10">
              <Grid item sm={12}>
                <div className="profileOtpInput mobileBg">
                  <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    rowSpacing={4}
                  >
                    <Grid item sm={9} className="textCenter">
                      <div>
                        <Typography className="fontBold font36 colorBlue m0">
                          Enter Your <span className="colorYellow">OTP</span>
                        </Typography>
                        <Typography className="colorGrey font16 fontNormal m0 pb10">
                          An authentication ITER code has been sent to &nbsp;
                          <span className="colorGrey font16 fontMedium marginBottom35">
                            {props?.countryCode + " " + props?.value}
                          </span>
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item sm={9}>
                      <form onSubmit={handleSubmit(onSubmit)}>
                        {/* ---OTP UI--- */}
                        <Grid
                          container
                          justifyContent="center"
                          alignItems="center"
                          spacing={1}
                        >
                          {verifyProfieLoader || updateProfileLoader ? (
                            <div className="height86">
                              <BackDrop />
                            </div>
                          ) : (
                            <Grid item sm={8} className="otpInput">
                              <Controller
                                name="otp"
                                control={control}
                                rules={{
                                  required: "OTP is required",
                                  minLength: {
                                    value: 4,
                                    message: "OTP must be 4 characters long",
                                  },
                                }}
                                render={({ field }) => (
                                  <OtpInput
                                    containerStyle="otp"
                                    inputStyle={
                                      errors.otp
                                        ? "otpStyleError"
                                        : "otpStyle"
                                    }
                                    value={field.value}
                                    onChange={(value) => {
                                      field.onChange(value);
                                      handleOtpChange(value);
                                    }}
                                    inputType="tel"
                                    numInputs={4}
                                    renderInput={(props) => (
                                      <input {...props} disabled={isLoader} />
                                    )}
                                    shouldAutoFocus={autoFocusOtp}
                                  />
                                )}
                              />
                              {errorOtp && (
                                <p className="errorOtp">
                                  <span>
                                    <ErrorIcon />
                                  </span>
                                  {errorOtp}
                                </p>
                              )}
                            </Grid>
                          )}
                          <Grid
                            container
                            item
                            sm={8}
                            justifyContent="center"
                            className="otpInput"
                          >
                            {/* ---Timer Screen--- */}
                            <Grid item>
                              <div>
                                <Timer
                                  value={props?.value}
                                  setAutoFocusOtp={setAutoFocusOtp}
                                  onResend={onResend}
                                  profile="true"
                                />
                              </div>
                            </Grid>
                          </Grid>
                        </Grid>
                      </form>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default CommonOtpDialog;
